<template>
  <div>
    <div class="content">
      <section>
        <span>1、选择平台</span>
        <el-tabs v-model="platformCategory" @tab-click="handlePlatformCategory">
          <el-tab-pane label="国内平台" name="gn">
            <div class="platforms">
              <el-badge v-for="(item, idx) in platforms_gn" :key="idx" :hidden="!platformAuthorizedShopNums[item.key]" :value="platformAuthorizedShopNums[item.key]" type="primary" class="platforms-badge">
                <a class="item" @click="getShops(item.key)" :class="{ 'onshelf-selected-platform': source === item.key }">
                  <img :src="item.icon" />
                  <span>{{ item.name }}</span>
                </a>
              </el-badge>
            </div>
          </el-tab-pane>
          <el-tab-pane label="跨境平台" name="kj">
            <div class="platforms">
              <el-badge v-for="(item, idx) in platforms_kj" :key="idx" :hidden="!platformAuthorizedShopNums[item.key]" :value="platformAuthorizedShopNums[item.key]" type="primary" class="platforms-badge">
                <a class="item" @click="getShops(item.key)" :class="{ 'onshelf-selected-platform': source === item.key }">
                  <img :src="item.icon" />
                  <span>{{ item.name }}</span>
                </a>
              </el-badge>
            </div>
          </el-tab-pane>
        </el-tabs>
      </section>
      <section v-if="stepItems['chooseShops']">
        <div class="step-item">
            <span>{{stepItems['chooseShops']}}、选择已授权店铺</span>
            <template v-if="source && showShopManageBtns">
              <el-button type="primary" class="ml-10 step-btn-left" @click="handleAddShop">添加店铺</el-button>
              <el-button type="default" class="ml-10 step-btn" icon="el-icon-refresh" :class="{'is-refreshing': isRefreshingShopList}" @click="handleRefreshShopList">更新店铺列表</el-button>
            </template>
        </div>
        <div class="shop-wrp step-content">
          <div class="select-all" v-if="source">
              <el-radio-group v-model="shopType" @change="handleChangeShopType">
                <el-radio :label="1">平台店铺</el-radio>
                <el-radio :label="2">店铺组</el-radio>
              </el-radio-group>
          </div>
          <div v-if="shopType === 1" style="margin-top: 10px">
            <el-input-popup-editor
              v-model="queryShopName"
              title="请输入店铺简称/名称"
              placeholder="请输入店铺简称/名称"
              topHint="多个店铺简称/名称，以逗号分隔或每行一个店铺简称/名称"
              :autosize="{ minRows: 6, maxRows: 10 }"
              style="margin-right: 10px"
              width="220px"
              @keyup.enter.native="handleQueryShop"
            ></el-input-popup-editor>
            <el-button type="primary" @click="handleQueryShop">查询</el-button>
          </div>
          <div class="select-all" v-if="source && (shopList.length || shopGroupList.length)">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{ checkAll ? '取消全选' : '全选' }}</el-checkbox>
            <span class="tips">{{shopType === 1 ? '注：全量勾选，可能导致铺货缓慢，请耐心等待' : '注：仅显示包含所选平台店铺的店铺组，铺货仅针对对应平台店铺生效，非所选平台店铺将跳过铺货！'}} </span>
          </div>
          <template v-if="shopType === 1">
            <el-checkbox-group v-model="selectShops" style="margin-top: 15px">
              <span v-for="item in shopList" :key="item.shopId" style="margin: 0 10px 10px 0; display: inline-block">
                <el-checkbox :disabled="shopDisabled(item)" :label="item.shopId"> 
                  <el-image v-if="item.icon" style="height: 16px; vertical-align: middle;" :src="item.icon"></el-image>
                  {{ item.name }}
                  <el-tag v-if="item.alreadyPublish" size="mini" type="success">已铺货</el-tag>
                </el-checkbox>
                <el-popover v-if="item.abnormalState" placement="top" width="500px" trigger="hover">
                  <template>
                    该店铺处于 【{{ item.abnormalState }}】 状态，若已解除，可<el-button @click="secureAbnormal(item)" type="link">解除店铺异常</el-button>后进行铺货
                  </template>
                  <i slot="reference" class="el-icon-warning" style="color: red; font-size: 14px; vertical-align: top"></i>
                </el-popover>
                <el-popover v-if="item.videoState" placement="top" width="500px" trigger="hover">
                  <template>视频上传任务状态：<span class="text-orange">{{ item.videoState }}</span>，若勾选铺货，则无法发布视频</template>
                  <i slot="reference" class="el-icon-warning" style="color: red; font-size: 14px; vertical-align: top"></i>
                </el-popover>
                <!-- 鱼小铺状态提示 -->
                <el-popover v-if="item.xyIsPro === false" placement="top" width="500px" trigger="hover">
                  <template>多规格商品发布需要前往闲鱼后台开通鱼小铺</template>
                  <i slot="reference" class="el-icon-warning" style="color: red; font-size: 14px; vertical-align: top"></i>
                </el-popover>
           
              </span>
            </el-checkbox-group>
            <div v-if="showFreightWarning && hasNoFreightShop && type == 'single'" class="freight-warning-wrapper">
              <el-alert
                title=""
                type="error"
                :closable="true"
                @close="closeFreightWarning">
                <span style="font-weight:bold;font-size: 14px">
                不可选择的店铺未配置运费模板，会导致发布失败，请前往铺货配置 <span style="color:blue;cursor: pointer;" @click="goSettingTemplate">配置运费模版</span><span v-if="type == 'single'"> 或 <span style="color:blue; cursor:pointer; " @click="handleEdit">编辑资料</span></span> 配置运费模版后进行铺货
                </span>
              </el-alert>
            </div>
          </template>
          <template v-else-if="shopType === 2">
            <el-checkbox-group v-model="selectShops" style="margin-top: 15px">
              <span v-for="item in shopGroupList" :key="item.id" style="margin: 0 10px 10px 0; display: inline-block">
                <el-checkbox :label="item.id"> {{ item.groupName }} </el-checkbox>
              </span>
            </el-checkbox-group>
          </template>
          <div v-if="shopList && shopList.some(item=>item.uncheck)" class="tips"> 快手每日发布新增商品超过上限,超过上限的店铺不能勾选 </div>
        </div>
      </section>
      <section v-if="stepItems['confirmInfo'] && source === 'fxg' && selectShops.length && !isFastPulish && type != 'multi'">
        <span>{{stepItems['confirmInfo']}}、店铺商品发布信息确认</span>
        <div class="step-content">
          <el-button type="primary" @click="openConfirmInfoDialog">确认发布信息</el-button>
        </div>
      </section>
      <section v-if="stepItems['prePrice']">
        <span>{{stepItems['prePrice']}}、铺货价格与库存预览</span>
        <div class="step-content">
          <div> <el-button type="primary" @click="openPrePriceDialog">铺货价格预览</el-button></div>
          <div class="tips">
            <div v-if="checkControllerPriceData.fenxiaoBreakPrice === 1 && checkControllerPriceData.isDistribution">铺货价格已破价（铺货价格低于或高于分销控价），请查看详情 {{ checkControllerPriceData.isLimit ? '，破价将限制整款商品发布' : '' }}</div>
            <div v-if="checkControllerPriceData.shopPriceType === 1">铺货价格已经过价格配置计算，与列表价格不一致，请核对后铺货</div>
          </div>
        </div>
      </section>
      <section v-if="['fxg','kuaishou','pdd','jd','tb','tm','1688','yz','wxsph','xhs','xy'].includes(source) && hasGoodsFissionRule && stepItems['useAiFissionRule']">
        <span>{{stepItems['useAiFissionRule']}}、防重复铺货设置</span>
        <div class="step-content">
          <div style="color:#333;background:#E6A23C;padding:5px 10px;" class="mb-10">选择使用AI裂变规则，裂变生成多份商品信息，防止重复铺货。</div>
          <div class="mb-10">
            <el-checkbox v-model="useAiFissionRule">使用AI裂变规则</el-checkbox>
          </div>
          <UseFissionRule ref="useFissionRuleRef" v-if="useAiFissionRule" :selectShops="getIds().selectedShopList" />
        </div>
      </section>
      <section style="color: red" v-if="isShowYzTips">有赞更新铺货由于平台原因可能会导致更新无效</section>
    </div>
    <div class="shelf-dialog-footer flex align-center space-between">
      <div>
        <span v-if="type === 'multi'">已选择<el-link>{{ shopNum }}</el-link>家店铺</span>
      </div>
      <div>
        <el-button @click="handleCancelBtn">取 消</el-button>
        <el-button v-if="type === 'single'" type="primary"  @click="preViewFission">先预览，再铺货</el-button>
        <el-button v-if="type === 'multi' && ['fxg','pdd','tb','kuaishou','wxsph','xhs','jd'].includes(source)" type="primary" :loading="isPublishing" @click="handleBatchDistribution">确 定</el-button>
        <el-button v-else type="primary" :loading="isPublishing" @click="sure()">确 定</el-button>
      </div>
    </div>
    <OnShelfResult :visible="showResult" :close="hideResultDialog" :resultData="resultData" />
    <PddRelationDialog ref="PddRelationDialog" />
    <CheckCategoryDialog ref="CheckCategoryAiRef"/>
    <KttHandDialog ref="KttHandDialogRef" />
    <PostCheckDrawer ref="PostCheckDrawerRef" @confirm="confirm" />
    <BulkShelvesPrepriceDialog ref="bulkShelvesPrepriceDialogRef" />
    <CapacityWarnDialog ref="CapacityWarnDialogRef" @continueBulkShelve="postData" />
    <BatchDistributionGoodsCheckDialog 
      :platform='source' 
      :getIds="getIds" 
      @dialog-close="handleClose" 
      :selectShops="selectShops" 
      :showShopList="shopList" 
      @shelves="batchShelves"
      ref="BatchDistributionGoodsCheckDialogRef"
    />
    <CheckKd ref="checkKdRef" />
    <!-- <TbBatchShelvesConfig ref="TbBatchShelvesConfigRef" @ok="tbOkToShelves" /> -->
    <el-dialog :visible.sync="pddAuthorizeVisible" title="拼多多店铺授权">
      <div>
        以下拼多多店铺授权已过期，点击链接
        <a :href="pddAuthorizeResult.length ? pddAuthorizeResult[0].authUrl : ''" target="_blank">去授权</a>
        <div v-for="shop in pddAuthorizeResult" :key="shop.shopId">
          <div v-if="!shop.tokenValid" class="mgt12">
            {{ shop.shopName }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { PUHUO_PLATFORMS_MAP, UPDATE_UPHUO_PLATFORMS_MAP, CHANNELS } from '@/dictionary/platforms';

import { getAllShopList, secureAbnormalStates } from '@servers/base/shop/index.js';
import { fxgCatStatus } from '@servers/prod/center/fxg';
import { publishGoods, publishConfirmValid_v2 } from '@/servers/prod/center';
import OnShelfResult from '@components/prod/center/components/OnShelfErrorResult';
import DdianInfoForm from '@components/prod/center/components/DdianInfoForm/index.vue';
import KttHandDialog from '@components/prod/center/dialogs/KttHandDialog.vue';
import PddRelationDialog from '@components/prod/center/dialogs/PddRelationDialog.vue';
import PostCheckDrawer from '@components/prod/center/dialogs/PostCheckDrawer/index.vue';
import BulkShelvesPrepriceDialog from '@components/prod/center/dialogs/BulkShelvesPrepriceDialog/index.vue';
import CapacityWarnDialog from '@components/prod/center/dialogs/capacityWarnDialog.vue';
import TbBatchShelvesConfig from '@components/prod/center/dialogs/TbBatchShelvesConfig.vue';
import CheckCategoryDialog from '@components/prod/center/BasicComps/CheckCategoryDialog.vue'
import UseFissionRule from '@/components/prod/goodsFissionRule/components/UseRule.vue'
import CheckKd from './CheckKd.vue'

import BatchDistributionGoodsCheckDialog from '@components/prod/center/BasicComps/BatchDistributionGoodsCheck/index.vue'
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { getPddShopAuthStatus } from '@/api/base';
import { get, cloneDeep, isEmpty } from 'lodash';
import { reqPddCarouselVideoInfo, preCheckControllerPrice } from '@/api/prod/center';
import { getScmCompanyConfCache } from "@/servers/prod/conf/index";

import { buildOssImgUrl } from '@/utils/oss-img';


export default {
  components: {
    OnShelfResult,
    DdianInfoForm,
    PddRelationDialog,
    KttHandDialog,
    PostCheckDrawer,
    BulkShelvesPrepriceDialog,
    CapacityWarnDialog,
    TbBatchShelvesConfig,
    CheckCategoryDialog,
    BatchDistributionGoodsCheckDialog,
    UseFissionRule,
    CheckKd,
  },
  props: {
    openEdit: Function,
    closeEdit: Function,
    openDistribitionTool: Function,
    smallShopItem: Boolean,
    origin:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      visible: false,
      type: '', // 'single' | 'multi'
      scmCompanyConf: {},
      rowsData: [],
      platforms: [],
      platformAuthorizedShopNums: {},
      queryShopName: '',
      shopAllList: [],
      selectShops: [],
      source: '',
      shops: {},
      showProgress: false,
      timeoutId: null,
      resultData: {},
      showResult: false,
      shopList: [],
      showEditDialog: false,
      saveEditSuccessed: false, // 保存编辑成功
      isPublishing: false, // 防止重复点击铺货按钮
      fxgForm: {},
      isDistributor: false, // isDistributor 表示是分销商端的分销商品页面和展架页面共同的逻辑
      publishType: '',
      publishEntrance: '',
      checkAll: false,
      isRefreshingShopList: false,
      isIndeterminate: true,
      info_platform: '',
      pddAuthorizeVisible: false,
      pddAuthorizeResult: [],
      fxgTipDialogVisible: false,
      channel: '',
      channelList: Object.values(CHANNELS),
      shopType:1, // 1 平台店铺 2店铺组
      shopGroupList:[],
      shopGroupMap:{},
      checkControllerPriceData: {},
      prePriceSaveData: {},
      useAiFissionRule:false,
      platformCategory:'gn',
      openSource:'',
      showFreightWarning: true,  // 运费模板警告是否展示，弹窗打开时重置为true
    };
  },
  computed: {
    ...mapGetters(['prodRePublishRowData', 'routerPrefix', 'displayRePublishData', 'shops_authorizedShops','get_AllShops_BySource','goodsFissionRulesList','hasGoodsFissionRule', 'publishItemLimit', 'publishedTotalCount']),
    stepItems() {
      const stepItems = ['choosePlatform','chooseShops'];
      
      // if (this.source !== 'wd') {
      //   stepItems.push('chooseShops');
      // }
      const shouldShowConfirmInfo = this.source === 'fxg' && this.selectShops.length && !this.isFastPulish;
      if (shouldShowConfirmInfo) {
        stepItems.push('confirmInfo');
      }
      if (!!this.checkControllerPriceData.shopPriceType || !!this.checkControllerPriceData.fenxiaoBreakPrice) {
        stepItems.push('prePrice');
      }
      if(this.type === 'single'){
        // 防重复铺货这一项放着最后
        stepItems.push('useAiFissionRule');
      }
      return stepItems.reduce((result, item, index) => {
        result[item] = index + 1;
        return result;
      }, {});
    },
    shopNum() {
      return this.selectShops.length;
    },
    allShopList() {
      if(this.shopType === 2){ // 店铺组
        return this.shopGroupList.map(group => group.id);
      }
      return this.shopList.filter(item => !(!!item.abnormalState || this.isFreightTemplateDisabled(item) || item.uncheck)).map(shop => shop.shopId);
      
    },
    isShowYzTips() {
      // 是否展示有赞更新的tips
      return this.publishType == 'EDIT_ITEM' && this.source === 'yz';
    },
    showShopManageBtns() {
      // 铺货入口 publishEntrance:
      // 0: 商品资料铺货 / 平台商品 (包含通过 bulkShelves.vue 外部调用的“找好货”场景)
      // 1: 分销商品铺货
      // 2: 供销商展架铺货 (包含“找好货”/寻合作等内部流程)
      return [0, 1, 2].includes(Number(this.publishEntrance)) && this.publishType !== 'EDIT_ITEM';
    },
    isFastPulish() {
      // 是否是一键铺货
      // const publishFastPlatformType = this.$store.getters.userInfo.publishFastPlatformType || []
      const publishFastPlatformType = this.scmCompanyConf.publishFastListDto || []
      let allCanPublishPlatform = []
      this.rowsData.forEach(row => {
        allCanPublishPlatform = allCanPublishPlatform.concat(row.canPublishPlatform || [])
      })
      return publishFastPlatformType.includes(this.source) && !allCanPublishPlatform.includes(this.source)
    },
    platforms_gn(){
      return this.platforms.filter(p => !p.isKj)
    },
    platforms_kj(){
      return this.platforms.filter(p => p.isKj)
    },
    /**
     * 计算属性：当前店铺列表中是否存在未配置运费模板的店铺
     * 基于当前过滤后的 shopList（可能是搜索过滤结果）做判断，确保响应式更新
     */
    hasNoFreightShop() {
      return this.shopList.some(shop => !shop.isCheckFreightTemplate)
    },
  },
  watch: {
    selectShops: {
      handler(val) {
        if (this.allShopList.length) {
          const isSame = val.length === this.allShopList.length && this.allShopList.every(item => val.includes(item));
          this.checkAll = isSame;
          this.isIndeterminate =  val.length > 0 && !isSame;
        } else {
          this.checkAll = false;
          this.isIndeterminate = false;
        }
        this.checkControllerPrice()
      },
      immediate: true,
    },
    visible() {
      this.$emit('visibleChange', this.visible);
    },
  },
  created() {
    // 货源池直接进入铺货路由，没有初始化店铺，导致用户授权失败，这里初始化一下
    if(this.$fromGyl){
        this.initShops(); 
    }
    this.channel = this.$fromGyl ? 'xygyl' : ''
    this.getGoodsFissionRules(); // 获取一下ai裂变规则
  },
  methods: {
    ...mapActions(['initShops', 'publishSpeed', 'clearRePublishRowData', 'clearDisplayRePublishRowData','getGoodsFissionRules', 'fetchPlatformQuota']),
    shouldBlockPublishByCapacity() {
      if (this.publishItemLimit === null) return false;
      if (this.publishItemLimit === undefined) return false;
      const limit = Number(this.publishItemLimit);
      if (!isFinite(limit)) return false;
      const used = Number(this.publishedTotalCount) || 0;
      return used >= limit;
    },
    ...mapMutations(['setCurrentPage']),
    async handleBatchDistribution(){
      let { shopIds, baseItemIds } = this.getIds();
      if (!this.source) {
        this.$message.warning('请选择平台!');
        return;
      }
      if (!this.selectShops.length) {
        this.$message.warning('请选择店铺!');
        return;
      }
      // this.handleClose()
      if (this.source === 'pdd') {
        // pdd铺货需要判断店铺是否授权
        let flag = await this.judgePddAuthorization();
        if (!flag) {
          return;
        }
      }
      if (this.type === 'multi') {
        // 批量铺货或更新
        // if (!this.isAllInfoComplete() && this.publishType !== 'EDIT_ITEM') {
        //   // 当前平台所有商品信息不完整 且 不为批量更新时
        //   this.$message.warning('您选择的商品中包含资料尚未完整的商品，无法批量铺货！');
        //   return;
        // }
      } else {
        if(this.checkControllerPriceData.fenxiaoBreakPrice && this.checkControllerPriceData.isLimit && this.checkControllerPriceData.isDistribution) {
          this.$message.warning('铺货价格已破价（铺货价格低于或高于分销控价），请查看详情，破价将限制整款商品发布');
          this.openPrePriceDialog()
          return 
        }
      }

      // if(this.source == 'fxg'){
      //   const res = await this.checkCategoryAi()
      //   // 校验类目AI预测
      //   if(!res){
      //     return
      //   }
      // }
      this.$refs.BatchDistributionGoodsCheckDialogRef.method_open({rowsData:this.rowsData})
    },
    handleAddShop() {
      if (!this.source) {
        this.$message.warning('请选择平台');
        return;
      }
      // 目标店铺管理页：默认本项目内路由跳转；仅星云供应链（$fromGyl）新开标签
      // 星云供应链场景下，强制跳分销端店铺管理
      const isXYGYL = !!this.$fromGyl;
      // const isXYGYL = true;
      // 使用登录身份判断分销/供销端，而不是依赖当前页面上下文的 isDistributor
      const isDistributorUser = this.$store.getters.isDistributor;
      const targetPath = isXYGYL
        ? '/distributor/shopManage'
        : (isDistributorUser ? '/distributor/shopManage' : '/supplier/shopManage');
      const routeData = this.$router.resolve({ path: targetPath });

      if (isXYGYL) {
        try {
          // 当前弹框是在iframe里，跳转时需要用当前iframe的src地址，只更改redirectUrl参数
          let redirectUrl = `/distributor/shopManage?createShop=true&source=${this.source}`;
          let targetUrl = `${window.location.origin}/account/ocean/redirectScm.json?redirectUrl=${encodeURIComponent(redirectUrl)}`;
          
          const newWin = window.open('about:blank');
          fetch(targetUrl)
            .then(response => response.json())
            .then(res => {
              if (res.result === 1 && res.data && res.data.redirectUrl) {
                newWin.location.href = res.data.redirectUrl;
              } else {
                newWin.location.href = routeData.href;
              }
            })
            .catch(e => {
              console.error('URL处理异常', e);
              newWin.location.href = routeData.href;
            });
        } catch (e) {
          console.error('URL处理异常', e);
          window.open(routeData.href, '_blank');
        }
      } else {
        // 避免重复导航到当前路由导致 NavigationDuplicated 错误
        if (this.$route.path === targetPath) return;
        this.$router.push({ 
          path: targetPath,
          query: {
            createShop: true,
            source: this.source
          }
        }).catch(err => err);
      }

      // 授权弹窗不在此处处理，仅跳转到店铺管理页
    },
    async handleRefreshShopList() {
      if (!this.source) {
        this.$message.warning('请选择平台');
        return;
      }
      this.isRefreshingShopList = true;
      // 清除平台店铺缓存并重新拉取（复用选择平台的 allShop 接口）
      if (this.shops && this.shops[this.source]) {
        delete this.shops[this.source];
      }
      try {
        await this.getShops(this.source);
      } finally {
        this.isRefreshingShopList = false;
      }
    },
    handleEdit(){
      // 确保 rowsData 存在且有数据
      if (!this.rowsData?.length) {
        this.$message.warning('没有可编辑的数据');
        return;
      }
      const rowData = {...this.rowsData[0],activeName: this.source}
      this.listItemInfo && this.listItemInfo.$refs.editDialog.method_open(rowData);
      this.handleClose()
    },
    goSettingTemplate(){
      const item = this.platforms.find(item=>item.key == this.source)
      const key = item.key
      // * loginIdentity(1:供销商； 2:分销商)
      let userInfo = this.$store.getters.userInfo;
        this.isSupplier = userInfo.loginIdentity === 1 ? true : false;
      this.$router.push({
        path: !this.isSupplier ? '/distributor/prod_conf' : '/supplier/prod_conf',
        query: { platform: key, platformName: item.name, tabName:'distribution' },
      });
      this.handleClose()
    },
    handleQueryShop(){
      let shopList = []
      const queryShopName = (this.queryShopName || '').trim()
      if(!queryShopName){
        shopList = cloneDeep(this.shopAllList)
      } else{
        // 支持英文逗号、汉字逗号 分隔多个店铺名称
        const keywords = queryShopName.split(/[,，]+/).map(k => k.trim()).filter(Boolean)
        shopList = this.shopAllList.filter(item => {
          if (keywords.length === 1) {
            // 单个关键词时支持模糊搜索
            const kw = keywords[0]
            return item.shortTitle?.includes(kw) || item.title?.includes(kw)
          }
          return keywords.some(kw => item.shortTitle === kw || item.title === kw)
        })
      }
      this.shopList = shopList
      // 搜索过滤后重新计算警告状态（基于过滤后的店铺列表判断）
      this.updateFreightWarning()
    },
    /**
     * 关闭运费模板警告提示（点击警告右上角×按钮）
     * 关闭后本次弹窗生命周期内不再展示，重新打开弹窗重置
     */
    closeFreightWarning() {
      this.showFreightWarning = false;
    },
    /**
     * 基于当前 shopList 判断是否展示运费模板警告
     * 条件：仅 type 为 single 时判断，multi 模式不拦截
     * 调用时机：切换平台、搜索过滤时
     */
    updateFreightWarning() {
      // single 模式：所有平台判断运费模板；multi 模式：不做判断（批量铺货不拦截）
      if (this.type !== 'single') {
        this.showFreightWarning = false;
        return;
      }
      // 基于当前 shopList 重新计算是否展示警告
      this.showFreightWarning = this.shopList.some(shop => !shop.isCheckFreightTemplate);
    },
    // 全选：只勾选已配置运费模板的店铺，禁用项不加入选中列表
    handleCheckAllChange(val) {
      if (val) {
        // 全选时过滤掉 isCheckFreightTemplate=false 的店铺，避免选中禁用的店铺
        this.selectShops = this.shopList
          .filter(item => item.isCheckFreightTemplate !== false)
          .map(shop => shop.shopId);
      } else {
        this.selectShops = [];
      }
    },
    /**
     * 判断店铺是否因运费模板未配置而禁用
     * 规则：仅在 type === 'single'（单个铺货）时校验，multi 模式不拦截
     * @param {Object} item - 店铺数据
     */
    isFreightTemplateDisabled(item) {
      // 只在单个铺货模式下禁用未配置运费模板的店铺
      return item.isCheckFreightTemplate === false && this.type === 'single';
    },
    shopDisabled(item){
      return !!item.abnormalState || this.isFreightTemplateDisabled(item) || item.uncheck || item.xyIsPro === false
    },
    handleCancelBtn(){
      this.handleClose();
      if(this.$fromGyl){
        this.$emit('iframeClose', this.visible);
      }
    },
    handleClose() {
      this.$fromGyl && this.closeEdit();
      this.visible = false;
      this.isPublishing = false;
      this.saveEditSuccessed = false; 
      if (this.prodRePublishRowData) {
        this.clearRePublishRowData();
      }
      if (this.displayRePublishData) {
        this.clearDisplayRePublishRowData();
      }
      if (this.info_platform) {
        this.info_platform = '';
      }
      if (this.source === 'tm') return; // 天猫不做搜索
      // this.$emit('search'); 铺货成功后不需要刷新列表
    },
    async secureAbnormal(row) {
      const res = await secureAbnormalStates({
        shopIdAndTypes: row.shopId + '_' + row.source,
        cacheType: 'SHOP_ABNORMAL_STATE',
        operateType: 'DELETE',
      });
      if (res) {
        this.$message.success('操作成功');
        row.abnormalState = '';
      }
    },
    async getScmCompanyConf() {
      let data = await getScmCompanyConfCache()
      this.scmCompanyConf = data;
    },
    method_open(type, data, { isDistributor, canPublishPlatform=[], publishType, publishEntrance, platform,listItemInfo } = {}) {
      this.publishType = publishType;
      this.publishEntrance = publishEntrance;
      this.isDistributor = !!isDistributor;
      this.listItemInfo = listItemInfo;
      this.rowsData = data;
      if (platform && platform !== 'base') {
        this.info_platform = platform;
      }
      this.type = type;
      // EDIT_ITEM 代表为更新铺货
      let platforms =
        this.publishType == 'EDIT_ITEM'
          ? UPDATE_UPHUO_PLATFORMS_MAP
          : type === 'multi'
          ? PUHUO_PLATFORMS_MAP // 天猫暂不支持批量铺货
          : PUHUO_PLATFORMS_MAP;

      platforms = platforms.filter(item => {
        if(item.key === 'fxg_gxzy') {
          const companyId = this.$store.getters.userInfo.companyId
          // 134945: 快麦自营店, 251752: 17网测试
          return [134945, 251752].includes(companyId)  
        }
        return true
      })
      platforms.forEach(item => {
        this.platformAuthorizedShopNums[item.key] = this.shops_authorizedShops(item.key).length
      })
      platforms = platforms.sort((a, b) => this.platformAuthorizedShopNums[b.key] - this.platformAuthorizedShopNums[a.key])
      // 获取上一次铺货使用的平台类型
      let puhuo_platform_category = localStorage.getItem('puhuo_platform_category')
      if(puhuo_platform_category){
        this.platformCategory = puhuo_platform_category
      }
      this.platforms = platforms
      this.visible = true;
      this.source = '';
      this.selectShops = [];
      this.queryShopName = '';
      this.shopList = [];
      this.shops = {};
      this.showFreightWarning = true;  // 弹窗打开重置警告状态，每次打开都重新计算
      if (this.prodRePublishRowData) {
        this.getShops(this.prodRePublishRowData.platform);
      }
      if (this.displayRePublishData) {
        this.getShops(this.displayRePublishData.platform);
      }
      if (this.info_platform) {
        this.getShops(this.info_platform);
      }
      this.getScmCompanyConf()
    },
    async getShops(source) {
      this.shopType = 1; // 切换平台后默认选中【平台店铺】
      let subSource = '';
      if (source == 'tjb') {
        subSource = 'tjb';
      } else {
        subSource = '';
      }
      this.source = source;
      this.selectShops = [];
      this.queryShopName = '';
      if (this.shops[source]) {
        this.shopList = this.shops[source];
        return;
      }
      const res = await getAllShopList(
        {
          source: source == 'tjb' ? 'tb' : source,
          subSource: subSource,
          baseItemId: this.type ==='multi'?'':this.rowsData[0]?.baseItemId,
          channel: this.channel,
        },
        { isNeedLoading: false }
      );
      // 拼多多视频审核状态
      let pddShopVideoStatus = {};
      let { baseItemIds, shopIds } = this.getIds();
      if (source === 'pdd') {
        let res = await reqPddCarouselVideoInfo({ baseItemIds });
        (res.data || []).forEach(item => {
          let videoInfo = item.videoInfo || [];
          let videoDesc = [];
          videoInfo.forEach(item => {
            if (item.videoState == 2) return;
            videoDesc.push(`${item.outIds.join(',')}:${item.videoStateDesc}`);
          })
          pddShopVideoStatus[item.shopId] = videoDesc.length ? videoDesc.join(';') : '';
        });
      }
      function iseExpire(data){
        if(data){
          let now = Date.now();
          let time = new Date(data).getTime();
          return time - now > 0
        }
        return true
      }
      if (res && res.list) {
        this.shopList = res.list
          .filter(item => (item.state === 2 || item.state === 3) && iseExpire(item.deadline))
          .map(item => {
            let result = {
              id: item.id,
              shopId: item.id,
              userId: item.userId,
              shortTitle: item.shortTitle,
              title: item.title,
              shopName: item.shortTitle || item.title,
              alreadyPublish: item.alreadyPublish,
              name: item.shortTitle || item.title,
              icon: item.icon,
              taobaoId: item.taobaoId,
              itemComplete: item.itemComplete,
              source: item.source,
              abnormalState: item.abnormalState,
              isCheckFreightTemplate: item.isCheckFreightTemplate,
              uncheck: item.uncheck,
              xyIsPro: item.xyIsPro
            };
            if (pddShopVideoStatus[item.id]) {
              result.videoState = pddShopVideoStatus[item.id];
            }
            return result;
          });
        this.shopAllList = cloneDeep(this.shopList)
        this.shops[source] = this.shopList.slice(0);
        this.isRefreshingShopList = false;
        // 切换平台后重新计算运费模板警告状态（基于当前平台店铺列表判断）
        this.updateFreightWarning();
        // 重新铺货
        if (this.prodRePublishRowData) {
          this.selectShops = [this.prodRePublishRowData.shopId];
          // 如果有baseItemId 说明导入商品资料可以打开编辑页面
          // 如果无则不打开编辑页面
          if (this.prodRePublishRowData.baseItemId && this.prodRePublishRowData.platform != 'tm') {
            if (this.prodRePublishRowData.platform === 'pdd') {
              let flag = await this.judgePddAuthorization();
              if (!flag) {
                return;
              }
            }
            if(this.source === 'ktt') {
              this.openKttEdit(baseItemIds, shopIds)
              return;
            } else {
              this.openEdit(
                _.assign({}, this.prodRePublishRowData, { activeName: this.source, successCallback: this.saveDataSuccess.bind(this) })
              );
            }
            
          }
          return;
        }
        if (this.displayRePublishData) {
          this.selectShops = [this.displayRePublishData.shopId];
          return;
        }
      }
    },
    isAllInfoComplete() {
      let source = ['fxg_gxzy', 'fxg_gx'].includes(this.source) ? 'fxg' : this.source   // 抖音分校
      if(this.isFastPulish || this.saveEditSuccessed) return true
      let flag = 0;
      for (let row of this.rowsData) {
        if (!row.canPublishPlatform || row.canPublishPlatform.indexOf(source) === -1) {
          flag += 1;
        }
      }
      if (flag === this.rowsData.length) {
        return false;
      }
      return true;
    },
    isFail(result) {
      let flag = true;
      for (let item of result) {
        if (item.failedList && item.failedList.length) {
          flag = false;
        }
      }
      return flag;
    },
    getResultData(result) {
      const failedList = [];
      let successNum = 0;
      result.forEach(r => {
        if (r.failedList && r.failedList.length) {
          r.failedList.forEach(fail => {
            failedList.push({ outerId: r.outerId, ...fail });
          });
        } else {
          successNum += 1;
        }
      });
      return {
        successNum: successNum,
        failedList: failedList,
      };
    },
    // 查询铺货进度
    saveDataSuccess(params, isPreview) {
      if(isPreview && params.isNoProgress) {
        this.postData(params,() => {
          this.closeEdit();
          // 跳转任务中心页面
          this.goPage('task_center')
        });
        return
      }
      if(this.source === 'tm') {
        this.saveEditSuccessed = true;
      } else {
        this.closeEdit();
        this.postData(params);
      }
    },
    async checkControllerPrice() {
      const needCheckPlatforms = ['fxg', 'kuaishou', 'tb', 'pdd', 'jd', 'tm', '1688','tjb', 'yz', 'wxsph', 'wxxd', 'wd', 'xhs','yyjk', 'xy', 'pddtemu','shein']
      this.checkControllerPriceData = {}
      this.prePriceSaveData = {}
      let { shopIds, baseItemIds } = this.getIds();
      if(!needCheckPlatforms.includes(this.source) || this.type !== 'single' || !shopIds.length) return
      const res = await preCheckControllerPrice({
        itemId: baseItemIds[0],
        shopIds,
        platformType: this.source
      })
      this.checkControllerPriceData = res?.data || {}
    },
    getIds(rowsData) {
      let shopIds = [];
      const outerIds = [];
      if(this.shopType === 1) {// 平台店铺
        shopIds = cloneDeep(this.selectShops)
      } else if(this.shopType === 2) { // 店铺组
        this.selectShops.forEach(id => {
            let obj = this.shopGroupList.find(item => item.id === id) || {};
            let arr = obj.shopIds?.split(',') || [];
            arr = arr.map(id => Number(id));
            shopIds = shopIds.concat(arr);
        });
      }

      let baseItemIds = (rowsData || this.rowsData).map(row => {
        outerIds.push(row.outerId);
        if (this.isDistributor) {
          // 0，1 跟 2 一样, baseItemIds中的值也是取得baseItemId
          return row.distributionBaseItemIds?.length ? row.distributionBaseItemIds[0] : row.baseItemId;
          // return this.publishEntrance == 2 ? row.baseItemId : row.supplierItemId;
        } else {
          return row.itemId ? row.itemId : row.baseItemId;
        }
      });
      return {
        baseItemIds,
        shopIds,
        outerIds,
        selectedShopList: shopIds.map(shopId => this.shopList.find(item => item.shopId === shopId)),
        rowsData:rowsData || this.rowsData
      };
    },

    /**
     * 铺货类型 publishType: PUBLISH_ITEM - 铺货   EDIT_ITEM - 更新铺货
     * 铺货入口 publishEntrance:  0-商品资料铺货  1-分销商品铺货  2-供销商展架铺货
     * shopIds: 铺货店铺ID列表
     * baseItemIds: 商品资料铺货
     * supplierItemInfos: 分销商品铺货（分销商品、供销商展架）
     */
    async postData(extraParams={}, cb) {
      let res;
      const { isNoProgress,...reset } = extraParams
      this.isPublishing = isNoProgress ? false : true;
      if(!isNoProgress){
        // 检查供应商是否存在对应平台的电子面单
        const checkKdResult = await this.checkKdPublish();
        if (checkKdResult === 'CANCEL') {
          return;
        }
      } 
      let { shopIds, baseItemIds } = this.getIds();
      // const shopList = shopIds.map(shopId => ({ shopId, channel: this.channel }));
      // KMERP-111714
      if (this.source === 'pdd') {
        let relationInfoParams = {
          itemIdList: baseItemIds,
        };
        if (this.isDistributor) {
          if (this.publishEntrance == 2 || this.publishEntrance == 1) {
            // 分销商品页及选款页需要传新的字段
            relationInfoParams.itemIdListV2 = this.rowsData.map(item => {
              return {
                itemId: this.publishEntrance == 2 ? item.baseItemId : item.supplierItemId,
                companyId: this.publishEntrance == 2 ? item.companyId : item.supplierCompanyId,
                isDistributor: this.publishEntrance == 2 ? item.isDistributor : true,
              };
            });
          } else {
            relationInfoParams.companyId = this.rowsData[0].supplierCompanyId;
          }
        }
      }
      let publishType = this.publishType;
      let params = {
        itemIds: baseItemIds,
        shopIds,
        taskEntrance: this.publishEntrance,
        taskType: this.publishType,
        channel: this.channel,
        batchOperationEntrance: this.type === 'multi' ? 1 : 0,
        isDistribution:+(this.$store.getters.userInfo.loginIdentity == 2),
        ...reset,
      }
      if(!isEmpty(this.prePriceSaveData)) {
        const { shopSkuInfoConfigs, publishCommonConfigs } = this.prePriceSaveData
        params.publishCommonConfigs = publishCommonConfigs
        if(params.publishShopConfigs?.length) {
          params.publishShopConfigs.forEach(item => {
            item.skuInfoConfigs = shopSkuInfoConfigs[item.shopId]
          })
        } else {
          params.publishShopConfigs = Object.keys(shopSkuInfoConfigs).map(shopId => {
            return {
              shopId,
              skuInfoConfigs: shopSkuInfoConfigs[shopId]
            }
          })
        }
      }
      let publishUrl = undefined
      if(this.source === 'fxg_gxzy') {
        publishType = 'FXG_GXPT_PUBLISH_ITEM'
        params = {
          baseItemIds,
          shopIds,
          publishEntrance: 0,
          publishType,
          channel: this.channel,
          isDistribution:+(this.$store.getters.userInfo.loginIdentity == 2),
        }
        publishUrl = '/item/platform/publish'
      } else if (this.isDistributor && this.publishEntrance == 2) {
        // 供销商展架页
        params.supplierItemInfos = this.rowsData.map(row => {
          return {
            supplierItemId: row.baseItemId,
            supplierCompanyId: row.companyId,
          }
        });
      }
      res = await publishGoods(params, publishUrl)
      if (res) {
        if(isNoProgress){
          cb && cb();
          return
        }
        //铺货进度查询
        if (this.publishEntrance == 0) {
          this.setCurrentPage(`${this.routerPrefix}goods`);
        } else if (this.publishEntrance == 1) {
          this.setCurrentPage(`${this.routerPrefix}distributor`);
        } else if(this.publishEntrance == 5){
          this.setCurrentPage(`${this.routerPrefix}shopGoods`);
        } else {
          this.setCurrentPage(`${this.routerPrefix}display`);
        }

        let speedType = publishType
        if(params.fissionGoodsExecuteType == 2){ // 存在裂变任务的铺货
          speedType = 'GOODS_FISSION'
        }
        await this.publishSpeed({ publishType:speedType, resultVisible: true, batchTaskId: this.source === 'fxg_gxzy' ? '' : res });
        this.isPublishing = false;
        this.visible = false;
      } else {
        this.isPublishing = false;
        this.$message.warning('商品铺货失败');
      }
    },
    hideResultDialog() {
      this.showResult = false;
    },
    openKttEdit(baseItemIds, shopIds) {
      this.$refs.KttHandDialogRef.method_open({
        baseItemIds, shopIds, isDistributor: this.isDistributor,
        okFn: (groupData, itemIds) => {
          this.postData({ batchTaskSchedulingConfig: groupData, itemIds});
        }
      });
    },
    async checkKdPublish() {
      const { baseItemIds } = this.getIds();
      // 组件可能已被销毁（如 handleClose 后 successCallback 异步触发），此时 refs 全部为 undefined
      if (!this.$refs.checkKdRef) {
        console.warn('checkKdRef 未就绪，跳过电子面单校验');
        return;
      }
      const checkKdResult = await this.$refs.checkKdRef.open(this.source, baseItemIds,{origin:this.origin});
      if (checkKdResult === 'CANCEL') {
        return 'CANCEL';
      }
      if (checkKdResult && Array.isArray(checkKdResult)) {
        this.rowsData = this.rowsData.filter(row => checkKdResult.includes(row.baseItemId));
      }
    },
    async sure(isPreview) {
      let { shopIds, baseItemIds } = this.getIds();

      if (!this.source) {
        this.$message.warning('请选择平台!');
        return;
      }
      // 微店铺货到店铺
      if (!this.selectShops.length) {
        this.$message.warning('请选择店铺!');
        return;
      }
      if (this.source === 'ktt') {
        this.openKttEdit(baseItemIds, shopIds)
        return;
      }

      if (this.source === 'pdd') {
        // pdd铺货需要判断店铺是否授权
        let flag = await this.judgePddAuthorization();
        if (!flag) {
          return;
        }
      }
      if (this.shouldBlockPublishByCapacity()) {
        await this.$confirm('铺货容量已达上限，若需要继续铺货，请联系销售人员！', '提示', {
          confirmButtonText: '我知道了',
          showCancelButton: false,
          type: 'warning',
        }).catch(() => {});
        return;
      }
      let params = {};
      if (this.useAiFissionRule) {
        params.isNoProgress = isPreview; // preview场景不走进度接口
        const batchFissionConfig = this.getFissionRuleData();
        params.batchPublishParams = batchFissionConfig;
        console.log(batchFissionConfig, isPreview, '---batchFissionConfig-')
        if (batchFissionConfig.length) {
          params.fissionGoodsExecuteType = isPreview ? 1 : 2;
        } else if (isPreview) {
          params.isNoProgress = false; // 无裂变配置时恢复走正常铺货流程
        }
      }

      if (this.type === 'multi') {
        // 批量铺货或更新
        if (!this.isAllInfoComplete() && this.publishType !== 'EDIT_ITEM') {
          // 当前平台所有商品信息不完整 且 不为批量更新时
          this.$message.warning('您选择的商品中包含资料尚未完整的商品，无法批量铺货！');
          return;
        }
      } else {
        // 单个铺货，不管资料是否完善，都弹出铺货窗口，便于用户核价
        if (!this.isAllInfoComplete() || this.smallShopItem) {
          !this.smallShopItem && this.$message.warning('商品平台信息填写不完整! 请先编辑信息保存');
          if(['fxg_gxzy', 'fxg_gx'].includes(this.source)) return
          this.openEdit(
            _.assign({}, this.rowsData[0], {
              activeName: this.source,
              selectShops: shopIds,
              selectShopList: this.shopList.filter(item => shopIds.includes(item.shopId)),
              successCallback: this.saveDataSuccess.bind(this, params, isPreview),
            }),
            {
              openSource: params.isNoProgress ? 'previewPublish' : '',
            }
          );
          return;
        }

        if(this.checkControllerPriceData.fenxiaoBreakPrice && this.checkControllerPriceData.isLimit && this.checkControllerPriceData.isDistribution) {
          this.$message.warning('铺货价格已破价（铺货价格低于或高于分销控价），请查看详情，破价将限制整款商品发布');
          this.openPrePriceDialog()
          return 
        }
      }
      // 清除重新铺货信息
      if (this.prodRePublishRowData) {
        this.clearRePublishRowData();
      }
      // 清除供销商展架铺货信息
      if (this.displayRePublishData) {
        this.clearDisplayRePublishRowData();
      }

      // 抖音铺货前需要二次确认
      if (['fxg', 'tb', 'pdd', '1688','jd'].includes(this.source) && !this.isFastPulish) {
        const data = await this.secConfirmationItemV2();
        const { noFinishedList, capacityList, noCheckedList, allData } = data;

        if (capacityList.length) {
          // 校验店铺素材中心容量
          this.$refs.CapacityWarnDialogRef.method_open({ capacityList, source: this.source });
        } else if (noCheckedList.length && this.source === 'fxg') {
          // 店铺关联信息后置校验
          this.openConfirmInfoDialog();
        } else if (noFinishedList.length) {
          // 校验资料完整性及针对平台规则调整进行自动重试的机制
          const firstBaseItemId = noFinishedList[0].baseItemId;
          const needEditItem = this.rowsData.find(row => row.baseItemId == firstBaseItemId || row.supplierItemId == firstBaseItemId);
          this.openEdit(_.assign({}, needEditItem, { activeName: this.source }));
          this.handleClose();
          setTimeout(() => {
            let failMsgs = '';
            noFinishedList.forEach(fail => {
              if (fail.outerId && fail.failMsg.filter(Boolean).length) {
                failMsgs += `<p style="padding: 5px;">商家编码 ${fail.outerId} ：【${fail.failMsg.join(',')}】!</p>`;
              }
            });
            if (failMsgs) {
              this.$message({
                type: 'warning',
                dangerouslyUseHTMLString: true,
                message: failMsgs,
                duration: 6000,
              });
            }
          }, 300);
        } else {
          if (this.source === 'tb' && this.type === 'multi') {
            const _shops = JSON.parse(JSON.stringify(this.shopList));
            this.$refs.TbBatchShelvesConfigRef.method_open({
              shopList: this.selectShops.map(shopId => _shops.find(item => item.shopId === shopId)),
            });
            return;
          } 
        }
        const isMatchFxgCheckWhiteUrlAndVideo = allData?.some(item => item.fxgCheckInfoVoList?.some(cI => ['whiteBackGroundPicUrl', 'videoInfo'].includes(cI.name) && cI.isExist === 0 ))
        // if(isMatchFxgCheckWhiteUrlAndVideo) {
        if(false) {   // 这个提示暂时去掉
          this.$confirm('<div>存在<span style="color: #f00">白底图/商品视频缺失</span>商品，根据抖音平台视觉合规检测要求，白底图/商品视频缺失，使用第三方商品发布工具发布商品时，仅支持发布至草稿箱。请前往商品资料调整，若继续铺货，将强制发布至草稿箱!</div>', '提示', {
            dangerouslyUseHTMLString: true,
            showClose: false,
            confirmButtonText: '前去调整',
            cancelButtonText: '继续铺货'
          }).then(() => {
            this.openEdit(_.assign({}, this.rowsData[0], { activeName: this.source, successCallback: this.saveDataSuccess.bind(this, params, isPreview) }));
          }).catch(action => {
            if(action === 'cancel') {
              this.postData(params, () => {
                if(isPreview) {
                  // 跳转任务中心页面
                  this.goPage('task_center')
                }
              });
            }
            
          });
          return;
        }
      }
      this.postData(params, () => {
        if(isPreview) {
          // 跳转任务中心页面
          this.goPage('task_center')
        }
      });
    },
    batchShelves(params,cb){
      this.postData(params,cb);
    },
    // tbOkToShelves(configParams) {
    //   this.postData(configParams);
    // },
    // 抖音进行铺货的类目校验
    async checkCategoryAi(){
      let { shopIds, baseItemIds, outerIds } = this.getIds();

      // 用于存储匹配不上的baseItemId（错挂的）
      const unmatchedIds = [];

      const params = {
        shopIds,
        baseItemIds
      }
      const data = await fxgCatStatus(params)
      baseItemIds.forEach(id  => {
        // 在resultList中查找当前id对应的item，且要求item.hit 为true
        const matchedItem = data.find(item  => item.baseItemId  === id && item.hit  === true);
        // 如果没有找到，则说明该id匹配不上
        if (!matchedItem) {
          unmatchedIds.push(id); 
        }
      });
      // 输出匹配不上的id列表
      const unmatchedData = data.filter(item=>unmatchedIds.includes(item.baseItemId))
      return new Promise((resolve, reject) => {
          if(unmatchedData.length == 0){
            // ，如果匹配不到，或者hit=true的，就不用管
            resolve(true)
          } else {
            if(baseItemIds.length == 1){
              this.$refs.CheckCategoryAiRef.method_open({
                type:'single',
                list: unmatchedData,
                rowsData:this.rowsData,
                cb:  (data)=>{
                  if(data){
                    resolve(true)
                  } else {
                    resolve(false)
                  }
                },
              })
            }
            if(baseItemIds.length>1){
              this.$refs.CheckCategoryAiRef.method_open({
                type:'multi',
                list: unmatchedData,
                rowsData:this.rowsData,
                cb: (data)=>{
                  if(data){
                    resolve(true)
                  } else {
                    resolve(false)
                  }
                },

              })
            }
          }
        })
      
    },
    async secConfirmationItemV2() {
      let { shopIds, baseItemIds, outerIds } = this.getIds();
      const shopList = shopIds.map(shopId => ({ shopId, channel: this.channel }));
      const data = await publishConfirmValid_v2({
        platformType: this.source === '1688' ? 'a1688' : this.source,
        itemShopList: baseItemIds.map((baseItemId, idx) => ({ baseItemId, shops: shopList, outId: outerIds[idx] })),
      });
      const noFinishedList = data.filter(item => !item.finished);
      let allCapacityList = [];
      let allNoCheckedList = [];
      data.forEach(item => {
        const capacityList = item.capacityList || [];
        const itemShopList = item.itemShopList || [];
        capacityList.forEach(capacity => {
          if (!allCapacityList.find(all => all.shopId === capacity.shopId)) {
            allCapacityList.push(capacity);
          }
        });
        allNoCheckedList = allNoCheckedList.concat(itemShopList.filter(item => !item.checkResult));
      });
      return { noFinishedList, capacityList: allCapacityList, noCheckedList: allNoCheckedList, allData: data };
    },
    openConfirmInfoDialog() {
      const { shopIds, baseItemIds } = this.getIds();
      this.$refs.PostCheckDrawerRef.method_open({ shopIds, baseItemIds });
    },
    openPrePriceDialog() {
      const { shopIds, selectedShopList, baseItemIds } = this.getIds();
      this.$refs.bulkShelvesPrepriceDialogRef.method_open({ 
        shopList: selectedShopList,
        baseItemIds, 
        isDistribution: this.rowsData[0]?.isDistribution, 
        platform: this.source,
        okFn: (prePriceSaveData) => {
          this.prePriceSaveData = prePriceSaveData
          this.checkControllerPriceData.fenxiaoBreakPrice = 0
          this.checkControllerPriceData.shopPriceType = 0
        }
      });
    },
    
    confirm() {
      this.sure();
    },
    async judgePddAuthorization() {
      let shopIds = [];
      if(this.shopType === 1){// 平台店铺
          shopIds = this.shopList.map(item => {
              if (this.selectShops.includes(item.shopId)) {
                return +item.taobaoId;
              }
              return null;
          });
      }else if(this.shopType === 2){ // 店铺组            
            let _shopList = this.shops[this.source];
            let _shopIds = [];
            this.selectShops.forEach(id => {
                let obj = this.shopGroupList.find(item => item.id === id) || {};
                let arr = obj.shopIds?.split(',') || [];
                _shopIds = _shopIds.concat(arr);
            });
            shopIds = _shopIds.map(shopId => {
                let obj = _shopList.find(item => item.shopId === shopId) || {};
                return +obj.taobaoId;
            });        
      }
      shopIds = shopIds.filter(Boolean);
      let res = await getPddShopAuthStatus({
        shopIds,
      });
      let data = (this.pddAuthorizeResult = get(res, 'data', []));
      let flag = data.every(item => {
        return item.tokenValid;
      });
      // 有过期店铺的就弹窗
      if (!flag) {
        this.pddAuthorizeVisible = true;
        return false;
      }
      return true;
    },
    getShopGroupList(){
        if(this.shopGroupMap[this.source] && this.shopGroupMap[this.source].length){
            this.shopGroupList = this.shopGroupMap[this.source];
            return;
        }
        this.$erpApi.get('groupInfo/queryUserGroupByPlatSource', {
          source:this.source
        }).then(res => {
            this.shopGroupList = res.data || [];
            this.shopGroupMap[this.source] = [...this.shopGroupList];
            this.checkAll = false;
            this.isIndeterminate = true;
        });
    },
    handleChangeShopType(val){
      if(val === 2){
        this.getShopGroupList();
      }
      this.shopType = val;
      this.selectShops = [];
      this.queryShopName = '';
    },
    buildOssImgUrl(url, size) {
      return buildOssImgUrl(url, size || 100);
    },
    handlePlatformCategory(){
      this.source = ''
      this.selectShops = [];
      this.queryShopName = '';
      this.shopList = []
      this.shopGroupList = [];
      // 记住上一次的选择,下次进来默认选中
      localStorage.setItem('puhuo_platform_category',this.platformCategory)
    },
    // 获取AI爆款裂变规则店铺配置数据
    getFissionRuleData(){
      let baseItemId = this.rowsData[0]?.baseItemId || ''
      let fissionData = this.$refs.useFissionRuleRef.getData();
      let batchFissionConfig = []
      if(fissionData.type === 1){
        let selectShops = fissionData.selectShops
        batchFissionConfig = selectShops.map(shop => {
          return {
            fissionRuleId:fissionData.ruleId,
            fissionNumber:fissionData.fissionNumber,
            itemId:baseItemId,
            shopId:shop.shopId
          }
        });
      }else if(fissionData.type === 2){
        batchFissionConfig = (fissionData.list || []).map(item => {
          return {
            fissionRuleId:item.ruleId,
            fissionNumber:item.fissionNumber,
            itemId:baseItemId,
            shopId:item.id
          }
        })
      }
      return batchFissionConfig.filter(item => item.fissionRuleId)
    },
    preViewFission(){
      this.sure(true)
      return
      let params = {
        isNoProgress:this.useAiFissionRule, // true 不走正常铺货流程，提交完任务后直接结束，不用调进度接口
      };
      // ai爆款裂变规则
      if(this.useAiFissionRule){
        let batchFissionConfig = this.getFissionRuleData();
        params.batchPublishParams = batchFissionConfig;
        if(batchFissionConfig.length === 0){
            params.isNoProgress = false // 没有裂变配置设置为false，可以走正常铺货流程
        }else{
          params.fissionGoodsExecuteType = 1
        }
      }
      let { shopIds, baseItemIds } = this.getIds();
      // 未完善资料弹出编辑弹窗
      if (!this.isAllInfoComplete() || this.smallShopItem) {
        // !this.smallShopItem && this.$message.warning('商品平台信息填写不完整! 请先编辑信息保存');
        // if(['fxg_gxzy', 'fxg_gx'].includes(this.source)) return
        const success = () =>{
            this.postData(params,() => {
                this.closeEdit();
              // 跳转任务中心页面
              this.goPage('task_center')
            });
        }
        this.openEdit(
          _.assign({}, this.rowsData[0], {
            activeName: this.source,
            selectShops: shopIds,
            successCallback: params.isNoProgress ? success : null,
          }),
          {
            openSource:params.isNoProgress ? 'previewPublish' : '',
          }
        );
        return;
      }
      this.postData(params,() => {
        // 跳转任务中心页面
        this.goPage('task_center')
      });
    },
    // 页面跳转
    goPage(name,params){
        this.$store.dispatch("setIsKeepAlive", false); // 跳转目标页面不使用缓存页面，重新加载
        this.$router.push({
          name: `${this.routerPrefix}${name}`,
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .step-content {
    margin: 10px 20px;
  }
  font-size: 12px;
  .platforms,
  .channels {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 15px;
    .item {
      width: 75px;
      border: 1px solid transparent;
      display: flex;
      flex-direction: column;
      margin-right: 10px;
      margin-bottom: 10px;
      cursor: pointer;
      text-decoration: none;
      color: #2c3e50;
      text-align: center;
      align-items: center;
      &.onshelf-selected-platform {
        border: 1px solid #2695fa;
        border-radius: 5px;
      }
      &.onshelf-selected-channel {
        border: 1px solid #2695FA;
        border-radius: 5px;
      }
      img {
        width: 70px;
        height: 70px;
        margin-bottom: 10px;
      }
    }
    .platforms-badge {
      ::v-deep .el-badge__content.is-fixed {
        transform: translateY(-30%) translateX(30%);
      }
    }
  }
  .channels {
    .item {
      padding: 4px;
    }
  }
  .tips {
    padding-bottom: 10px;
    color: #ff0000;
  }
  .select-all {
    display: flex;
    align-items: center;
    margin-top: 15px;
    .tips {
      padding-bottom: 0;
      padding-left: 10px;
    }
  }
  .is-refreshing {
    ::v-deep .el-icon-refresh {
      animation: rotating 2s linear infinite;
    }
  }
}
.shelf-dialog-footer {
  padding: 10px 15px;
  border-top: 1px solid #ebebeb;
  font-size: 12px;
}

.step-item {
  ::v-deep .step-btn {
    border: none;
    color: #2695FA;
    margin-left: 0;
  }
  .step-btn-left{
    margin-left: 10px;;
  }
  // ::v-deep .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
  // }
}
</style>
